import type { ReactNode } from "react";

/**
 * Mono Caps tracking 0.14em. Max 6 Wörter.
 * accent → --accent-blue-soft.
 */

interface EyebrowProps {
  accent?: boolean;
  children: ReactNode;
  className?: string;
}

export function Eyebrow({ accent, children, className }: EyebrowProps) {
  const cls = `eyebrow${accent ? " eyebrow--accent" : ""}${className ? " " + className : ""}`;
  return <span className={cls}>{children}</span>;
}
